import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import map from 'lodash/map';

import Page from '../Page';

const selected = ({ hash, pathname }) =>
  /^\/contact\/?$/i.test(pathname) || hash === '#contact';

const socialMediaLink = (
  { profileUrl, serviceName, slug, username }, // eslint-disable-line react/prop-types
  index
) => (
  <li key={index}>
    <a
      className={slug}
      href={profileUrl}
      rel="noopener noreferrer"
      target="_blank"
      title={`Follow me on ${serviceName}.`}
    >
      {username}
    </a>
  </li>
);

const Footer = props => {
  const { location, siteMotto, title, vCard } = props;
  const {
    fullName,
    physicalAddress,
    emailAddress,
    phoneNumber,
    socialMedia,
  } = vCard;
  const {
    streetAddress,
    locality,
    region,
    postalCode,
    country,
  } = physicalAddress;
  return (
    <Page {...props} isSelected={selected(location)} tag="footer">
      <div className="tagline">
        <h3 className="motto">{siteMotto}</h3>
      </div>
      <p className="prompt">
        <span>Ready to get to work?</span>
        <span>Or still have some questions?</span>
        <a className="email" href={`mailto:${emailAddress}`}>
          Contact me.
        </a>
      </p>
      <div className="vcard">
        <p>
          <span className="name">
            <Link className="fn url u-url u-uid" rel="me" to="/">
              {fullName}
            </Link>
          </span>
          <span className="organization">
            <Link className="org" to="/">
              {title}
            </Link>
          </span>
        </p>
        <address className="p-adr h-adr">
          <span className="p-street-address">{streetAddress}</span>
          <span className="p-locality">{locality}</span>
          <span className="p-region">{region}</span>
          <span className="p-postal-code">{postalCode}</span>
          <abbr className="p-country-name" title={country.title}>
            {country.abbr}
          </abbr>
        </address>
        <ul className="contact">
          <li>
            <a
              className="p-email email"
              href={`mailto:${emailAddress}`}
              title="Send me an email."
            >
              {emailAddress}
            </a>
          </li>
          <li>
            <a
              className="p-tel tel"
              href={`tel:${phoneNumber}`}
              title="Give me an call."
            >
              {phoneNumber}
            </a>
          </li>
        </ul>
        <ul className="social-media">
          {map(socialMedia, (service, index) =>
            socialMediaLink(service, index)
          )}
        </ul>
      </div>
      <p>
        All sites made with{' '}
        <span aria-label="hearts" role="img">
          💕
        </span>
        .
      </p>
    </Page>
  );
};

Footer.propTypes = {
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  siteMotto: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  vCard: PropTypes.shape({
    fullName: PropTypes.string.isRequired,
    physicalAddress: PropTypes.shape({
      streetAddress: PropTypes.string.isRequired,
      locality: PropTypes.string.isRequired,
      region: PropTypes.string.isRequired,
      postalCode: PropTypes.string.isRequired,
      country: PropTypes.shape({
        abbr: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    emailAddress: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    socialMedia: PropTypes.arrayOf(
      PropTypes.shape({
        profileUrl: PropTypes.string.isRequired,
        serviceName: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        username: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,
  }).isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js